//http://facebook.github.io/fixed-data-table/
import React from 'react';
import BaseReactComponent from '../../Util/BaseReactComponent';
import styles from './InstallerCompanyTable.scss';
import baseComponent from '../../../decorators/baseComponent';
import DataTable from '../../DataTable';
import {connect} from "react-redux";
import {getConfig} from "../../settings";

@connect(state => ({
  config: getConfig(state)
}))

@baseComponent(styles)
class InstallerCompanyTable extends BaseReactComponent {

  addNewInstallerCompany() {
    this.props.onAddNew();
  }

  onEditInstallerCompany(installerCompany) {
    this.props.onEditInstallerCompany(installerCompany);
  }

  render() {
    if (this.props.rows.length === 1 && this.props.rows[0] === 'loading') {
      return (<div className="loading-indicator">Loading...</div>);

    } else {
      let cols = [];
      cols.push('username');
      cols.push('companyName');
      cols.push('country2');
      if (this.props.config.supportsBeta) cols.push('beta2');
      cols.push('edit');
      return (<DataTable rows={this.props.rows} cols={cols}
                         onAddNew={this.addNewInstallerCompany.bind(this)} onEdit={this.onEditInstallerCompany.bind(this)}/>);
    }
  }
}

InstallerCompanyTable.propTypes = {
  rows: React.PropTypes.array,
  onAddNew: React.PropTypes.func,
  onEditInstallerCompany: React.PropTypes.func
};

export default InstallerCompanyTable;



// WEBPACK FOOTER //
// /src/components/HomePage/InstallerCompanyTable/InstallerCompanyTable.js